import React, { Component } from 'react';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

class PeriodsBox extends Component {

    constructor(props) {
        super(props);

        this.state = {
            periods: []
        }
    }

    componentDidMount() {
        this.getPeriods()
    }

    getPeriods() {

        fetch(process.env.REACT_APP_API_URL + "period/v1",
            {
                method: 'GET',
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('access_token')
                }
            })
            .then((resp) => resp.json())
            .then(data => {
                console.log(data)
                this.setState({ periods: data });
            });
    }

    render() {
        return (
            <Row>
                <Col>
                <Card>
                        <Card.Body>
                            <Card.Title>Blokken</Card.Title>
                            <Card.Text>
                                <Table borderless>

                                
                            {
                                    this.state.periods.map(period => {

                                        return (

                                            <tr key={period.id}>
                                                <td>
                                                    {period.name} 
                                                </td>
                                                <td>
                                                    {Date.parse(period.startDate) <= new Date() && Date.parse(period.endDate) >= new Date() ? ("Actief") : ("")} 
                                                </td>
                                            </tr>
                                        )
                                    })
                                }

                                {
                                    this.state.periods.length <= 0 ? ("Er zijn geen blokken") : ""
                                }
                                </Table>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        )
    }
}

export default PeriodsBox;